import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Button, Row, Col, notification } from "antd";
import { towingTariffService } from "../../../services";
import MaterialLikeInput from "../../../components/MaterialLikeInput";

const ModalForm = ({ visible, onClose, editData, setRefresh }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const isEditMode = editData?.id !== undefined;

  // Set initial values for edit mode
  useEffect(() => {
    if (editData) {
      form.setFieldsValue({ ...editData });
    } else {
      form.resetFields();
    }
  }, [editData, form]);

  const handleSubmit = async (values) => {
    setLoading(true)
    const response = isEditMode
      ? await towingTariffService.updateTariff(editData?.id, values)
      : await towingTariffService.addTariff(values);
    if (response.success ?? false) {
      notification.success({
        message: "Success",
        description: isEditMode
          ? "Towing Tariff updated successfully!"
          : "Towing Tariff added successfully",
        placement: "topRight",
      });
      setRefresh(true)
    } else {
      const errors = response.data?.errors || [response.message];
      notification.error({
        message: "Error",
        description: `Error: ${errors.join(", ")}`,
        placement: "topRight",
      });
    }
    setLoading(false)
    onClose();
  };

  return (
    <Modal
      title={editData ? "Edit Tariff" : "Add Tariff"}
      open={visible}
      onCancel={onClose}
      footer={null}
      centered

    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
      >
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item
              name="auctions"
              rules={[{ required: true, message: "Please input Auction!" }]}
            >
              <MaterialLikeInput
                label="Auction"
                required
                value={form.getFieldValue("auctions")}
                onChange={(e) => form.setFieldValue("auctions", e.target.value)}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="usd"
              rules={[{ required: true, message: "Please input USD!" }]}
            >
              <MaterialLikeInput
                label="USD"
                required
                value={form.getFieldValue("usd")}
                onChange={(e) => form.setFieldValue("usd", e.target.value)}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="state"
              rules={[{ required: true, message: "Please input State!" }]}
            >
              <MaterialLikeInput
                label="State"
                required
                value={form.getFieldValue("state")}
                onChange={(e) => form.setFieldValue("state", e.target.value)}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="state_code"
              rules={[{ required: true, message: "Please input Code!" }]}
            >
              <MaterialLikeInput
                label="Code"
                required
                value={form.getFieldValue("state_code")}
                onChange={(e) => form.setFieldValue("state_code", e.target.value)}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="ports"
              rules={[{ required: true, message: "Please input Ports!" }]}
            >
              <MaterialLikeInput
                label="Ports"
                required
                value={form.getFieldValue("ports")}
                onChange={(e) => form.setFieldValue("ports", e.target.value)}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item style={{ textAlign: "center" }}>
              <Button
                type="primary"
                htmlType="submit"
                style={{ width: "50%" }}
                loading={loading}
              >
                {editData ? "Update Tariff" : "Add Tariff"}
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default ModalForm;
